/**
 * Page size for a browsable publications list, and the service layer's default when a query omits `limit`.
 * `search-filters` holds an equal private copy (`DEFAULT_LOAD_LIMIT`) and builds the same publications
 * query — keep the two in sync so every path requests identical pages for identical criteria. This module
 * is pure (RTK-free), so `shared`-tagged consumers may import the constant directly.
 *
 * Kept in an import-free leaf module: the eager boot path retains this constant (publications service ←
 * `publication-common`'s load-publication saga ← the navigation provider), and anything this file imports
 * ships in the eager `app` bundle alongside it — the query builders in `query.args.ts` must not.
 */
export const DEFAULT_PUBLICATIONS_LOAD_LIMIT = 100;
